const view = {
  businessCard: 'businessCard',
  grid: 'grid',
  list: 'list'
};

export default view;
